import { render } from "./ProductsCombobox.vue?vue&type=template&id=5c707b54"
import script from "./ProductsCombobox.vue?vue&type=script&lang=js"
export * from "./ProductsCombobox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__